/* =====================================================================
   EverMount — automatic free gifts as $0 line items
   ---------------------------------------------------------------------
   Scoped to the products the snippet publishes in CFG.kits: the EverMount
   Battery-Operated Pet Water Fountain (8800377209062) and, since
   2026-09-20, the Essential Bundle (9452368855270). Nothing here touches
   any other product. The cleanup pass only ever edits lines it tagged
   itself with _wt_gift.

   Install: Shopify admin > Edit code > snippets > create
   `wt-evermount-gifts.liquid`, paste this inside <script> tags, then in
   theme.liquid immediately before </body>:

       {% render 'wt-evermount-gifts' %}

   It must load site-wide, not only on the fountain PDP: the ADD path
   fires only on the fountain, but the CLEANUP path has to run wherever
   a customer can empty their cart.
   ===================================================================== */
(function () {
  'use strict';

  /* Rendering the snippet twice would double-wrap fetch and double every
     add. Refuse to install a second copy. */
  if (window.__wtEverMountGifts) return;
  window.__wtEverMountGifts = 1;

  var CFG = {
    productId: 8800377209062,

    /* Variants that earn the gifts. Gifts attach to these and nothing else. The
       snippet replaces this with EVERY variant of the fountain AND of the
       Essential Bundle, so a variant added later is covered without touching
       this file. */
    kits: {
      '45249981055206': 'Starter Kit',
      '45249981087974': '90-Day Hydration Kit',
      '47386656538854': 'Essential Bundle - Gray',
      '47386656571622': 'Essential Bundle - Black'
    },

    /* variant id -> the product it belongs to, used only to tag a gift line with
       the product that earned it. Replaced by the snippet. */
    parents: {
      '45249981055206': 8800377209062,
      '45249981087974': 8800377209062,
      '47386656538854': 9452368855270,
      '47386656571622': 9452368855270
    },

    /* $0 hidden gift variants.
       TODO before launch: create the two products below in Shopify and
       paste their variant IDs. Mystery gift is already live. */
    gifts: [
      /* EverMount Cleaning Brush — UNLISTED, $0, sku EverMount-Brush */
      { key: 'brush',   id: '48310120480998' },
      /* Free Pumps for Life — UNLISTED, $0, non-shipping (warranty, not a pick) */
      { key: 'pumps',   id: '48310195880166' },
      /* Free Mystery Gift (Avogato catnip set) — sku avogato-catnip-toy-2-pack-gift.
         rebuy:true (owner 2026-09-18): Rebuy Smart Cart's own gift-with-purchase rule adds this
         one once the cart passes the threshold, and when this script added it as well the
         checkout showed TWO "Free Mystery Gift" lines (same variant, different line
         properties, so Shopify kept them apart). This script now NEVER adds it; the id stays
         listed so a line it tagged in an older cart is still recognised and removed, and so an
         untagged $0 copy (not added by Rebuy) is removed too; see unearned(). */
      { key: 'mystery', id: '43802072023270', minSubtotal: 10000, rebuy: true }
    ],

    /* Gifts multiply with fountain quantity (operator decision 2026-09-09). */
    scaleWithQuantity: true,

    /* All three set from Liquid. enabled: the fountain product is on the
       evermount-fountain-3 template, so the gift rule is live store-wide; until
       then this script only ever removes lines it tagged and never adds one.
       pdp: this page IS that template, the only place the ADD path may
       intercept a form. cartRelevant: the cart held a fountain or a gift line
       when the page rendered; when it did not, the page-load pass is skipped. */
    enabled: false,
    pdp: false,
    cartRelevant: true,

    timeoutMs: 10000
  };

  /* snippets/wt-evermount-gifts.liquid resolves the same ids from product
     HANDLES and publishes them here. Prefer those: a product that was deleted
     and recreated keeps its handle but gets a new id, and a stale id would make
     the gifts silently stop attaching. Anything the snippet could not resolve
     falls back to the literal above, and says so once. */
  (function mergeLiquidConfig(){
    var live = window.WT_GIFTS_CONFIG;
    if (!live) { warn('no Liquid config found; gifts stay off'); return; }
    CFG.enabled = !!live.enabled;
    CFG.pdp = !!live.pdp;
    CFG.cartRelevant = live.cartRelevant !== false;   /* absent (old snippet) = assume yes */
    if (live.productId) CFG.productId = live.productId;
    if (live.kits && Object.keys(live.kits).length) CFG.kits = live.kits;
    if (live.parents && Object.keys(live.parents).length) CFG.parents = live.parents;
    if (live.gifts && live.gifts.length) {
      CFG.gifts = CFG.gifts.map(function (g) {
        var hit = null;
        for (var i = 0; i < live.gifts.length; i++) if (live.gifts[i].key === g.key) hit = live.gifts[i];
        if (!hit) { warn('gift "' + g.key + '" did not resolve from its handle; using the compiled id ' + g.id); return g; }
        return { key: g.key, id: String(hit.id), price: hit.price, minSubtotal: hit.minSubtotal || g.minSubtotal, rebuy: !!g.rebuy };
      });
    }
    /* On the fountain PDP the buy box is the authority on the gift threshold, so both
       read the same number. They still measure different things on purpose: the tile
       shows whether THIS PRODUCT's total qualifies, while the rule below is applied to
       the whole cart, so a cart carrying other items can qualify while the tile is
       hidden. Erring toward giving the gift is the right way round. */
    var tiers = window.WT_PRICING && window.WT_PRICING.tiers;
    if (tiers && tiers.GIFT_MIN > 0) {
      CFG.gifts.forEach(function (g) { if (g.minSubtotal) g.minSubtotal = tiers.GIFT_MIN; });
    }
  })();

  var kitIds  = Object.keys(CFG.kits);
  var giftIds = CFG.gifts.map(function (g) { return String(g.id); });

  /* A "gift" is only a gift at $0. The ids are resolved from product HANDLES so they
     survive a product being recreated - which is the same mechanism that would silently
     attach a PRICED variant if one of these products were ever repriced or its handle
     reused. Every fountain buyer would then be charged for it with nothing in the UI
     showing the line. The snippet publishes each gift's Liquid price; refuse anything
     that is not zero, and say so once. */
  var refused = {};
  function isFree(g) {
    if (g.price == null) return true;            /* no price published: old snippet, trust the id */
    if (Number(g.price) === 0) return true;
    if (!refused[g.key]) {
      refused[g.key] = 1;
      warn('gift "' + g.key + '" (variant ' + g.id + ') costs ' + g.price +
           ' and will NOT be added. A free gift must be a $0 variant.');
    }
    return false;
  }

  function isKit(id)         { return kitIds.indexOf(String(id)) !== -1; }
  function isGiftVariant(id) { return giftIds.indexOf(String(id)) !== -1; }
  function configured(g)     { return !/^REPLACE_/.test(String(g.id)); }
  function ours(line)        { return !!(line.properties && line.properties._wt_gift === 'true'); }
  function giftFor(id) {
    for (var i = 0; i < CFG.gifts.length; i++) if (String(CFG.gifts[i].id) === String(id)) return CFG.gifts[i];
    return null;
  }
  /* A free gift line nobody earned (owner 2026-10-01). Every gift line this script adds
     carries _wt_gift, and Rebuy tags the mystery gift it adds with _source:Rebuy, so a $0
     gift line with neither got there some other way (a direct /cart/add link, a gift page
     opened with scripts off) and is removed on the next page that runs this script. A
     browser that never runs scripts, or a cart link that goes straight to checkout, is
     not caught here: only a server-side cart validation could. Rebuy's tag is honoured only on
     the gift Rebuy actually hands out (rebuy:true), so a brush line claiming to be from
     Rebuy is still removed. A gift product someone PAID for (price above 0) is untouched. */
  function unearned(line) {
    if (ours(line) || line.price !== 0) return false;
    var g = giftFor(line.variant_id);
    if (!g) return false;
    return !(g.rebuy && line.properties && line.properties._source === 'Rebuy');
  }
  /* Informational only - `ours()` keys off _wt_gift alone, so a cart that somehow
     holds both products still has every gift line recognised and tidied. It names
     the product that earned the gifts so an order can be read back. */
  function giftProps(variantId) {
    var parent = (variantId != null && CFG.parents) ? CFG.parents[String(variantId)] : null;
    return { _wt_gift: 'true', _wt_parent_product: String(parent || CFG.productId) };
  }
  function warn(m, e)        { if (window.console) console.warn('[EverMount gifts] ' + m, e || ''); }

  /* Captured before the patch at the bottom, so our own calls never re-enter it. */
  var nativeFetch = window.fetch.bind(window);

  /* ---- transport. Every request is time-boxed: one that never settles
     would otherwise pin the re-entrancy guard on forever. ---- */
  function req(url, opts, ms) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, ms || CFG.timeoutMs);
    var init  = Object.assign({ headers: { 'Accept': 'application/json' } }, opts || {});
    if (ctl) init.signal = ctl.signal;

    return nativeFetch(url, init).then(function (r) {
      return r.text().then(function (txt) {
        clearTimeout(timer);
        var data = null;
        try { data = txt ? JSON.parse(txt) : null; } catch (e) { /* non-JSON body */ }
        if (!r.ok) return Promise.reject({ status: r.status, data: data });
        return data;
      });
    }, function (e) { clearTimeout(timer); return Promise.reject(e); });
  }

  function postJSON(url, body) {
    return req(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }
  function getCart() { return req('/cart.js'); }
  /* A failed add is judged by "did the quantity go up", not "is the variant there" (audit
     M10, 2026-10-15): a shopper who already had a fountain saw a timed-out add reported
     as a success. */
  function planOf(line) {
    return line.selling_plan_allocation && line.selling_plan_allocation.selling_plan ? line.selling_plan_allocation.selling_plan.id : null;
  }
  /* Quantity of a variant in a cart. `plan` undefined: any plan; null: one-time only. */
  function qtyIn(items, variantId, plan) {
    return (items || []).reduce(function (n, i) {
      if (String(i.variant_id) !== String(variantId)) return n;
      if (plan !== undefined && String(planOf(i) || '') !== String(plan || '')) return n;
      return n + (Number(i.quantity) || 0);
    }, 0);
  }
  /* What the cart holds right before an add: a FRESH read, because a cached count can be
     stale (another tab, a drawer change this script never saw) and a stale-high count would
     turn a timed-out add that did not land into "landed", or one that did land into a
     re-add. Resolves null when the cart cannot be read; callers then fall back to the old
     "is the line there" test. */
  /* After the cart pre-create (a cookie-less read racing it could mint a second cart), and
     on a short leash of its own: a slow read must not hold the add for the full 10s. */
  function qtyBefore(variantId, plan) {
    return ensureCart().then(function () { return req('/cart.js', null, 2500); })
      .then(function (c) { return qtyIn(c && c.items, variantId, plan); }, function () { return null; });
  }

  /* FIRST-ADD CART RACE - fountain and Essential Bundle pages (owner 2026-09-23 for the
     fountain, extended to the bundle 2026-10-02, and to the Replacement Filters page
     2026-10-15 after the audit found 5 of 6 first-visit filter adds landing in an empty
     cart; window.__wtFiltersHead is set by wt-filters-head.liquid on that template only). A new visitor has no
     cart yet. Rebuy fires its own /cart/update.js (cart attribution) the moment it sees
     our /cart/add.js, so the two requests each create a cart, and whichever response
     lands last owns the cookie. When Rebuy's empty cart won (7 of 10 first-visit adds
     in testing), the drawer opened on "Your cart is empty". Rebuy fires on the button
     press itself, so creating the cart at click time only moved the race (1 in 10);
     the cart is created when the page loads (call below), and the add paths still wait
     on it in case the shopper taps before it has landed. window.__wtFountainHead is set
     only by wt-fountain-head.liquid on the evermount-fountain-3 template, and CFG.pdp only
     on that template and evermount-bundle-essential, so every other page keeps its current
     behaviour. Never rejects: if it fails, add anyway. */
  var cartReady = null, cartFailedAt = 0;
  function ensureCart() {
    if (!window.__wtFountainHead && !window.__wtFiltersHead && !CFG.pdp) return Promise.resolve();
    if (/(?:^|;\s*)cart=/.test(document.cookie)) return Promise.resolve();
    /* A pre-create that just failed is not retried by every step of the same tap (each one
       would wait out its own timeout, and a 429 would get more requests); add anyway. */
    if (Date.now() - cartFailedAt < 15000) return Promise.resolve();
    if (!cartReady) {
      cartReady = postJSON('/cart/update.js', {})['catch'](function (e) {
        warn('could not create the cart ahead of the add; adding anyway', e);
        cartReady = null;
        cartFailedAt = Date.now();
      });
    }
    return cartReady;
  }
  ensureCart();

  /* Add one line, never fatal. Resolves 1 if it landed, 0 if it did not. */
  function addOne(item) {
    return postJSON('/cart/add.js', { items: [item] }).then(function () { return 1; },
      function (e) { warn('could not add variant ' + item.id + ', continuing without it', e); return 0; });
  }

  /* ---- what the cart SHOULD contain, given the fountains in it ---- */
  /* The first gift-earning variant in the cart, so the gift lines can name the
     product that earned them. null when there is none. */
  function parentVariant(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (isKit(cart.items[i].variant_id)) return cart.items[i].variant_id;
    }
    return null;
  }

  function desiredGifts(cart) {
    var fountainQty = 0, payable = 0;

    cart.items.forEach(function (i) {
      if (isKit(i.variant_id)) fountainQty += i.quantity;
      /* only OUR free lines are excluded from the threshold: a gift a
         customer actually paid for should still count toward it */
      if (!ours(i)) payable += i.final_line_price;
    });

    var want = {};
    if (!CFG.enabled) return want;               /* rule not live yet: never add, only tidy */
    if (!fountainQty) return want;               /* no fountain, no gifts */

    var qty = CFG.scaleWithQuantity ? fountainQty : 1;
    CFG.gifts.forEach(function (g) {
      if (!configured(g)) return;
      if (g.rebuy) return;                                    /* Rebuy adds this one, never us */
      if (!isFree(g)) return;                                 /* priced: never attach it */
      if (g.minSubtotal && payable < g.minSubtotal) return;   /* threshold gift */
      want[String(g.id)] = qty;
    });
    return want;
  }

  /* ---- bring the cart in line with desiredGifts() ----
     `busy` stops our own writes from re-entering; `rerun` makes sure a
     mutation that lands mid-pass is not dropped. Callers must NOT test
     `busy` themselves — always call reconcile() and let it queue. */
  var busy = false, rerun = false;

  function reconcile() {
    if (busy) { rerun = true; return Promise.resolve(); }
    busy = true;

    return getCart().then(function (cart) {
      var want = desiredGifts(cart);
      var ops = [], seen = {};

      cart.items.forEach(function (i) {
        if (!isGiftVariant(i.variant_id)) return;
        /* Removed, and NOT marked seen: if the cart does earn this gift, the tagged line
           is added below in the same pass. */
        if (unearned(i)) { ops.push({ id: i.key, quantity: 0, _from: i.quantity }); return; }
        /* Mark every other gift-variant line seen, even one we do not own, so we
           never stack a second line on top of a gift the customer paid for. */
        seen[String(i.variant_id)] = true;
        if (!ours(i)) return;                     /* not ours: look, never touch */
        var target = want[String(i.variant_id)] || 0;
        /* Belt and braces for a price that changed after the page loaded: a line we
           added as free that is now charging is removed, not left in the cart. */
        if (target && i.price !== 0) {
          warn('gift variant ' + i.variant_id + ' is no longer free (' + i.price + '); removing it');
          target = 0;
        }
        /* keyed by line `key`, never by variant id: a variant-keyed update
           would also hit a gift the customer bought on purpose */
        if (i.quantity !== target) ops.push({ id: i.key, quantity: target, _from: i.quantity });
      });

      /* Legacy clean-up (2026-09-18): filter subscription lines added before the buy box
         stopped writing its visible "5-pack: ships every N months" property still carry it,
         and checkout printed it under Shopify's own subscription text. Properties cannot be
         edited in place, so such a line is re-added without the property (same variant,
         quantity and selling plan) and the old line removed. Runs once per line. */
      cart.items.forEach(function (i) {
        var props = i.properties || {}, legacy = null;
        Object.keys(props).forEach(function (k) {
          if (k.charAt(0) !== '_' && /^ships every /i.test(String(props[k] || ''))) legacy = k;
        });
        if (!legacy || !i.selling_plan_allocation) return;
        var keep = {};
        Object.keys(props).forEach(function (k) { if (k !== legacy) keep[k] = props[k]; });
        var readd = { id: i.variant_id, quantity: i.quantity, selling_plan: i.selling_plan_allocation.selling_plan.id };
        if (Object.keys(keep).length) readd.properties = keep;
        ops.push({ id: i.key, quantity: 0, _from: i.quantity, _readd: readd });
      });
      var earner = parentVariant(cart);
      var missing = Object.keys(want)
        .filter(function (id) { return !seen[id]; })
        .map(function (id) { return { id: Number(id), quantity: want[id], properties: giftProps(earner) }; });

      var done = 0;

      /* One failing op must not abandon the ops that follow it, and one
         sold-out gift must not suppress the others: everything below is
         sequential with a per-item catch. */
      var chain = ops.reduce(function (p, op) {
        return p.then(function () {
          var readd = op._readd, from = op._from; delete op._readd; delete op._from;
          return postJSON('/cart/change.js', op).then(function (c) {
            /* Count only a change that actually took effect. change.js answers 200 even
               when stock caps the quantity below what was asked, so "the request worked"
               would report a change on every pass (and reload /cart forever, below). */
            var now = 0;
            ((c && c.items) || []).forEach(function (l) { if (l.key === op.id) now = l.quantity; });
            if (now !== from) done++;
            if (readd) return addOne(readd).then(function (n) { if (!n) warn('legacy filter line was removed but could not be re-added', readd); });
          }, function (e) { warn('could not update a gift line', e); });
        });
      }, Promise.resolve());

      chain = missing.reduce(function (p, item) {
        return p.then(function () { return addOne(item).then(function (n) { done += n; }); });
      }, chain);

      return chain.then(function () { return done; });
    }).then(function (changed) {
      if (!changed) return;                       /* silent when nothing moved */
      /* The /cart page's form posts quantities by POSITION (updates[]), so once a line
         has gone from under it, its next submit would hand the quantities to the wrong
         lines. Reload it so the form matches the cart. Only changes that took effect are
         counted (above), so the reloaded page's pass finds nothing to do; as a backstop,
         never reload twice within 10s. */
      if (/^\/([\w-]+\/)?cart\/?$/.test(window.location.pathname)) {
        var last = 0;
        try { last = Number(window.sessionStorage.getItem('wtGiftReload')) || 0; } catch (e) { /* storage blocked */ }
        if (Date.now() - last > 10000) {
          try { window.sessionStorage.setItem('wtGiftReload', String(Date.now())); } catch (e) { /* storage blocked */ }
          window.location.reload();
          return;
        }
      }
      refreshCart();
    }, function (e) {
      warn('reconcile failed', e);
    }).then(function () {
      busy = false;
      if (rerun) { rerun = false; return reconcile(); }
    });
  }

  /* ---- ADD path: fountain PDP only ---- */
  function baseGifts(qty, variantId) {
    return CFG.gifts
      .filter(function (g) { return configured(g) && !g.minSubtotal; })
      .filter(function (g) { return !g.rebuy; })          /* Rebuy adds the mystery gift itself */
      .filter(isFree)
      .map(function (g) {
        return { id: Number(g.id), quantity: CFG.scaleWithQuantity ? qty : 1, properties: giftProps(variantId) };
      });
  }

  /* The filter add-on is not a form any more. The buy box (kit-selector in
     wt-fountain.js) publishes whatever it is charging for on window.WT_CART,
     and this is the only thing that turns that into a cart line, so the two
     can never disagree about the variant or the selling plan.

       window.WT_CART = { kit:{id}, filter:{id, selling_plan}|null }

     filter === null means the customer switched the add-on off. */
  function addonItems() {
    var c = window.WT_CART;
    if (!c || !c.filter || !c.filter.id) return [];   /* add-on switched off */
    var item = { id: Number(c.filter.id), quantity: 1 };
    if (c.filter.selling_plan) item.selling_plan = Number(c.filter.selling_plan);
    /* the buy box's visible note for the drawer ("Subscription : Ships every 2 months") */
    if (c.filter.properties && Object.keys(c.filter.properties).length) item.properties = c.filter.properties;
    return [item];
  }

  /* /cart/add.js is all-or-nothing, and Shopify's 422 body names the product
     TITLE, not the variant id, so there is nothing reliable to parse. Land
     the fountain first, then attempt everything else individually. */
  /* Resolves the number of ADD-ON lines (the filter the buy box quoted) that could not be
     added, so the caller can tell the shopper (audit M10): they used to be dropped with
     only a console warning, after "Total today" had quoted them. Gift lines are not
     counted; the reconcile pass after the add owns those. */
  function addFountainItems(main, extras, addons) {
    return postJSON('/cart/add.js', { items: [main].concat(extras) }).then(function () { return 0; }, function (err) {
      if (!err || err.status !== 422) throw err;
      warn('batch add rejected, retrying with the fountain alone', err);

      /* If this fails too the fountain itself is the problem: let it throw
         so the caller can decide about a fallback. */
      return postJSON('/cart/add.js', { items: [main] }).then(function () {
        var dropped = 0;
        return extras.reduce(function (p, item) {
          return p.then(function () {
            return addOne(item).then(function (n) { if (!n && addons && addons.indexOf(item) !== -1) dropped++; });
          });
        }, Promise.resolve()).then(function () { return dropped; });
      });
    });
  }

  /* One short line under the buy button when the filter add-on did not make it into the
     cart. Plain text, role=alert, removed on the next add. */
  var ADDON_FAILED = 'Your fountain is in your cart, but we couldn\u2019t add the filters. Please add them from the filters page.';
  function addonNote(form, show) {
    var box = form.querySelector('.wt-add-note');
    if (!show) { if (box) box.hidden = true; return; }
    if (!box) {
      box = document.createElement('p');
      box.className = 'wt-add-note';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin:8px 0 0;font-size:13px;line-height:1.4;';
      var btns = submitButtons(form), last = btns[btns.length - 1];
      if (last && last.parentNode) last.parentNode.insertBefore(box, last.nextSibling); else form.appendChild(box);
    }
    box.textContent = (window.WT_GIFTS_CONFIG && window.WT_GIFTS_CONFIG.addonFailedText) || ADDON_FAILED;
    box.hidden = false;
  }

  function readMain(form) {
    var fd = new FormData(form);
    var id = fd.get('id');
    /* FormData omits disabled inputs, and the theme ships name="id" disabled
       until ProductForm upgrades. Reading it any other way would let us
       preventDefault on a form we then cannot submit. */
    if (!id || !isKit(id)) return null;

    var main = { id: Number(id), quantity: Number(fd.get('quantity') || 1) };
    var plan = fd.get('selling_plan');
    if (plan) main.selling_plan = Number(plan);   /* gifts never carry a plan */

    var props = {};
    fd.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m) props[m[1]] = v;
    });
    if (Object.keys(props).length) main.properties = props;
    return main;
  }

  function submitButtons(form) {
    return [].slice.call(form.querySelectorAll('button[type="submit"], [name="add"]'));
  }

  /* A client-side abort says nothing about whether Shopify committed the
     add. Never blind-retry a non-idempotent request: read the cart back and
     only re-submit if the fountain genuinely is not there. */
  function recoverFromAddFailure(form, main, extras, err, before, addons) {
    warn('add to cart failed, checking whether it landed anyway', err);

    return getCart().then(function (cart) {
      /* Landed means the quantity went UP from what the cart held before the tap, not
         merely that the variant is in the cart (it may have been there already). */
      var have = qtyIn(cart.items, main.id);
      if (before == null ? have >= main.quantity : have > before) {
        warn('the add did land; not resubmitting');
        return 0;
      }
      /* Retry through the SAME multi-line path rather than resubmitting the theme form.
         A native form POST carries only name="id" - no filter line and no selling plan -
         so the customer would be charged for a fountain alone after being quoted a
         subscription in "Total today". The native submit is kept as the last resort,
         because a fountain in the cart beats nothing, and it says what it dropped. */
      return addFountainItems(main, extras, addons)['catch'](function (e3) {
        warn('retry failed; falling back to a plain form submit WITHOUT the add-on', e3);
        try { HTMLFormElement.prototype.submit.call(form); }
        catch (e4) { window.location.href = '/cart'; }
      });
    }, function (e2) {
      /* Cannot read the cart, so cannot prove the add did not land.
         Doing nothing risks a lost sale; resubmitting risks a double
         charge. The safe side is to leave the button live and let the
         customer retry deliberately. */
      warn('could not verify cart state; leaving the form for the customer to retry', e2);
      return Promise.reject(e2);   /* stops the drawer / redirect hand-off below */
    });
  }

  document.addEventListener('submit', function (e) {
    /* Bound to the new template, and only once the gift rule is live. On every
       other page - and on a ?view= preview of the new template before the
       product is switched over - the theme's own add-to-cart runs untouched. */
    if (!CFG.enabled || !CFG.pdp) return;
    var form = e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    var main = readMain(form);
    if (!main) return;                 /* not the fountain: theme handles it */
    /* the buy box's hidden kit labels ride on the product line (owner 2026-09-18);
       on the bundle page the same properties carry the colour */
    var wc = window.WT_CART;
    if (wc && wc.kit && String(wc.kit.id) === String(main.id) && wc.kit.properties) {
      main.properties = Object.assign({}, main.properties || {}, wc.kit.properties);
    }

    /* The Impact theme's ProductForm submit handler does not check
       defaultPrevented, so preventDefault alone would let it fire a second
       /cart/add and put two fountains in the cart. */
    e.preventDefault();
    e.stopImmediatePropagation();

    var btns = submitButtons(form), before = null;
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
    function release() {
      btns.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; });
    }

    var addons = addonItems();
    var extras = addons.concat(baseGifts(main.quantity, main.id));
    addonNote(form, false);

    ensureCart()
      .then(function () { return qtyBefore(main.id); })
      .then(function (n) {
        before = n;
        return addFountainItems(main, extras, addons);
      })
      ['catch'](function (err) { return recoverFromAddFailure(form, main, extras, err, before, addons); })
      .then(function (dropped) {
        /* The cart write is finished either way; do not hold the button
           for the reconcile pass behind it. */
        release();
        if (dropped) addonNote(form, true);
        return reconcile();          /* picks up the threshold gift */
      })
      .then(function () {
        /* Third-party hand-off: a throw in here must never be mistaken for
           a failed add and trigger a resubmit. openCart() opens the drawer now, or
           waits for Smart Cart to boot (Rebuy loads 3-4s after the page) and only
           falls back to /cart itself if it never appears. */
        try { refreshCart(); openCart(); }
        catch (e2) { warn('cart drawer hand-off failed', e2); }
      }, function (e3) {
        release();
        warn('post-add step failed', e3);
      });
  }, true);

  /* ---- cart drawer: the fountain line shows the KIT it was bought as (owner 2026-09-18):
     "Starter Kit" as the title, "Fountain + 1 Filter" as the line under it, instead of the
     product title and the variant title. The labels travel on the line as hidden
     properties (_wt_kit_name / _wt_kit_sub), so they are right on every page the drawer
     opens on. Rebuy re-renders its list on every cart change, so this re-applies on
     mutation; every write is guarded by an equality check, so it never loops. ---- */
  function relabelKits() {
    var sc = (window.Rebuy && window.Rebuy.SmartCart) ? window.Rebuy.SmartCart : null;
    var items = sc && sc.cart && sc.cart.items;
    var els = document.querySelectorAll('.rebuy-cart__flyout-item');
    if (!items || !els.length) return;
    /* Rebuy does not render every cart line as a row (its own gift-with-purchase line is
       hidden), so rows and items are NOT index-aligned. Match per product handle instead:
       the rows for one handle appear in the same order as that handle's cart lines. */
    var byHandle = {};
    items.forEach(function (it) {
      if (!it.properties || !(it.properties._wt_kit_name || it.properties._wt_note) || !it.handle) return;
      (byHandle[it.handle] = byHandle[it.handle] || []).push(it);
    });
    Object.keys(byHandle).forEach(function (handle) {
      var rows = [].filter.call(els, function (el) { return el.classList.contains('product-' + handle); });
      var lines = items.filter(function (it) { return it.handle === handle; });   /* every line of this product, in cart order */
      if (rows.length !== lines.length) return;                                    /* mid-render or unknown layout: next pass */
      rows.forEach(function (el, n) {
        var p = lines[n].properties || {};
        var t = el.querySelector('.rebuy-cart__flyout-item-product-title');
        if (!t) return;
        var v = el.querySelector('.rebuy-cart__flyout-item-variant-title:not(.wt-line-note)');
        if (p._wt_kit_name) {
          if (t.textContent.trim() !== p._wt_kit_name) t.textContent = p._wt_kit_name;
          if (p._wt_kit_sub) {
            if (!v) { v = document.createElement('div'); v.className = 'rebuy-cart__flyout-item-variant-title'; v.setAttribute('tabindex', '0'); t.parentNode.insertBefore(v, t.nextSibling); }
            if (v.textContent !== p._wt_kit_sub) v.textContent = p._wt_kit_sub;
          } else if (v && v.textContent.trim()) {
            v.textContent = '';
          }
        }
        /* "Ships every 2 months" under the subscribed filter row (drawer only) */
        var note = el.querySelector('.wt-line-note');
        if (p._wt_note) {
          if (!note) { note = document.createElement('div'); note.className = 'rebuy-cart__flyout-item-variant-title wt-line-note'; var after = v || t; after.parentNode.insertBefore(note, after.nextSibling); }
          if (note.textContent !== p._wt_note) note.textContent = p._wt_note;
        } else if (note) {
          note.parentNode.removeChild(note);
        }
      });
    });
  }
  (function watchDrawer() {
    if (!window.MutationObserver) return;
    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      (window.requestAnimationFrame || setTimeout)(function () { queued = false; try { relabelKits(); } catch (e) { warn('relabel failed', e); } });
    }
    function start() {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
      schedule();
    }
    if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  })();

  /* ---- cart hand-off ---- */
  function smartCart() {
    return (window.Rebuy && window.Rebuy.SmartCart) ? window.Rebuy.SmartCart : null;
  }
  /* Rebuy Smart Cart v2's real API, read off the live storefront:
       Rebuy.Cart.fetchCart(cb)     re-reads /cart.js and hands back the cart
       Rebuy.SmartCart.setCart(c)   swaps that cart into the drawer and enriches it
       Rebuy.SmartCart.show()       opens the drawer
       Rebuy.SmartCart.hide()       closes it
     There is no .refresh() and no .open(), and Rebuy does not patch fetch, so a
     custom /cart/add.js is invisible to it until we push the new cart in. The
     previous code here called sc.refresh() / sc.open(), found neither, and fell
     through to CustomEvents Rebuy does not listen for — which is why the drawer
     never opened after an add. */
  function rebuyCart()  { return (window.Rebuy && window.Rebuy.Cart)      ? window.Rebuy.Cart      : null; }

  function refreshCart() {
    /* The theme caches the cart and refetches on this event; it must fire
       whether or not Rebuy is present, or the header count goes stale.
       Note it takes no detail, unlike cart:change which the theme reads
       through event.detail.cart. */
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    var sc = smartCart(), rc = rebuyCart();
    if (!sc || !rc || typeof rc.fetchCart !== 'function') return;
    try {
      rc.fetchCart(function (cart) {
        if (!cart) return;
        try { sc.setCart(cart); } catch (e) { warn('Smart Cart would not take the new cart', e); }
      });
    } catch (e) { warn('could not re-read the cart for Rebuy', e); }
  }

  function openCart() {
    var sc = smartCart();
    /* show() is safe to call before the drawer has finished booting: it parks
       the request on pendingShow and opens as soon as status flips to ready. */
    if (sc && typeof sc.show === 'function') { sc.show(); return true; }
    /* Smart Cart has not booted yet. On the live storefront Rebuy's loader is injected
       AFTER the page has loaded - at 2s after load there is not even a script tag for it,
       window.Rebuy appears at 3-4s and Smart Cart is ready a moment later - so there is no
       way to tell "not yet" from "not installed" at click time. A customer who clicked
       inside that window used to be bounced to /cart. Wait for it (up to 8s), push the
       fresh cart in, open it; only give up to /cart if it never appears. */
    var waited = 0;
    (function poll() {
      var s2 = smartCart();
      if (s2 && typeof s2.show === 'function') { refreshCart(); s2.show(); return; }
      waited += 150;
      if (waited >= 8000) { warn('Smart Cart never booted; going to /cart'); window.location.href = '/cart'; return; }
      setTimeout(poll, 150);
    })();
    return true;
  }

  /* ---- shared cart API ----
     wt-fountain.js (the Bundle & Save "Add to Order" buttons) adds lines through
     this rather than calling /cart/add.js itself, so every add on the site goes
     through one implementation and one reconcile pass. */
  window.WTCart = {
    addLines: function (items) {
      return ensureCart().then(function () {
        return postJSON('/cart/add.js', { items: items });
      }).then(function (r) {
        return reconcile().then(function () { return r; });
      });
    },
    refreshCart: refreshCart,
    openCart: openCart,
    /* Promise of the quantity of a variant (plan: null = one-time) in the cart now; null if unreadable */
    qtyBefore: qtyBefore
  };

  /* ---- CLEANUP triggers ----
     After any cart mutation anywhere on the site, make the gift lines agree
     with the fountains actually in the cart. These never test `busy`:
     reconcile() queues an overlapping trigger so none is dropped. */
  /* Same-origin cart mutations only, matched on the pathname (locale prefixes
     like /fr/cart/add.js included) so a third-party URL or a query string that
     merely mentions /cart/add cannot trigger a pass. */
  function isCartMutation(input) {
    try {
      var u = new URL(String((input && input.url) || input || ''), window.location.href);
      return u.origin === window.location.origin &&
             /^\/([\w-]+\/)?cart\/(add|change|update|clear)(\.js)?$/.test(u.pathname);
    } catch (e) { return false; }
  }

  /* Until the rule is live, a cart with no fountain and no gift line can never
     need a pass, so nothing is watched and the page costs nothing extra. */
  if (CFG.enabled || CFG.cartRelevant) {
    window.fetch = function (input) {
      var mutating = isCartMutation(input);
      return nativeFetch.apply(null, arguments).then(function (res) {
        if (mutating) setTimeout(reconcile, 0);
        return res;
      });
    };

    /* Not every app mutates the cart over fetch. The theme broadcasts this
       after every change, and bfcache restores need a pass too. */
    document.documentElement.addEventListener('cart:change', function () {
      setTimeout(reconcile, 0);
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) reconcile(); });
  }

  /* Page-load pass: only when Liquid saw a fountain or a gift line in the cart.
     On any other page view there is nothing to reconcile and no request is made. */
  if (CFG.cartRelevant) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { reconcile(); });
    } else {
      reconcile();
    }
  }
})();
